import React from 'react';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';

export const BrandDiscoverPage = lazy(
  () =>
    import('./BrandDiscoverPage.eager').then(mod => ({
      default: mod.BrandDiscoverPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
